var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1799 6.25708V5.57143C16.1799 3.94289 14.8334 2.57143 13.128 2.57143C12.41 1.02863 10.884 0 8.99898 0C6.84473 0 5.04947 1.4572 4.60066 3.42857H4.51087C1.90782 3.42857 -0.246494 5.57143 0.0227908 8.14286C0.292024 10.3715 2.35662 12 4.69039 12H7.74226C7.92171 12 8.10127 11.8285 8.10127 11.6572V7.20003L6.93443 8.31425C6.75486 8.48573 6.57529 8.57147 6.30604 8.57147C6.03679 8.57147 5.85723 8.48573 5.67764 8.31437C5.31863 7.97155 5.31863 7.45723 5.67764 7.11441L8.37049 4.54298C8.72951 4.20015 9.26811 4.20015 9.62712 4.54298L12.32 7.11441C12.679 7.45723 12.679 7.97155 12.32 8.31437C11.961 8.6572 11.4224 8.6572 11.0633 8.31437L9.8965 7.20003V11.6572C9.8965 11.8286 10.0761 12 10.2555 12H14.6538C16.2695 12 17.7057 10.8858 17.975 9.34282C18.1546 7.97136 17.3466 6.7714 16.1798 6.25711L16.1799 6.25708Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.46e879993f119bcad3aee0c755c4f6ad.svg";
export { ForwardRef as ReactComponent };